import { render, staticRenderFns } from "./quoteNotifyInfo.vue?vue&type=template&id=347f9e32&scoped=true"
import script from "./quoteNotifyInfo.vue?vue&type=script&lang=js"
export * from "./quoteNotifyInfo.vue?vue&type=script&lang=js"
import style0 from "./quoteNotifyInfo.vue?vue&type=style&index=0&id=347f9e32&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347f9e32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('347f9e32')) {
      api.createRecord('347f9e32', component.options)
    } else {
      api.reload('347f9e32', component.options)
    }
    module.hot.accept("./quoteNotifyInfo.vue?vue&type=template&id=347f9e32&scoped=true", function () {
      api.rerender('347f9e32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/order/inquiry/components/quoteNotifyInfo.vue"
export default component.exports